/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTIcon} from '../../../../_metronic/helpers'
import {Link} from 'react-router-dom'

type Props = {
  id: number
  handleSelect: (id: number) => void
}

const ArticleAction = ({id, handleSelect}: Props) => {
  const onDelete = () => handleSelect(id)
  const onView = () => handleSelect(id)

  return (
    <div className='text-end'>
      <Link
        to={`/knowledgebase/article/update?id=${id}`}
        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 mb-1'
      >
        <KTIcon iconName='pencil' className='fs-3' />
      </Link>

      <Link
        to={`/knowledgebase/article-view/${id}`}
        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm mb-1 me-1 btn-color-info'
        onClick={onView}
      >
        <KTIcon iconName='eye' className='fs-3' />
      </Link>

      <button
        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm mb-1 btn-color-danger'
        data-bs-toggle='modal'
        data-bs-target='#kt_modal_2'
        onClick={onDelete}
      >
        <KTIcon iconName='trash' className='fs-3' />
      </button>
    </div>
  )
}

export default ArticleAction
